import { KeyboardDatePicker } from '@material-ui/pickers';
import React, { useEffect, useState } from 'react';

export default function DatePicker({ onChangeDate, getDate = () => {} }) {
  const [selectedDate, handleDateChange] = useState(new Date());
  const [opened, setOpened] = useState(false);

  // Sincroniza o estado interno (selectedDate) com o valor vindo do componente (date) no Kanban.js
  useEffect(() => {
    const parentDate = getDate();
    if (!!parentDate) {
      if (selectedDate !== parentDate) {
        handleDateChange(parentDate);
      }
    }
  }, [getDate, selectedDate]);

  return (
    <KeyboardDatePicker
      value={selectedDate}
      views={['year', 'month']}
      onChange={(date) => handleDateChange(date)}
      format="MM/YYYY"
      openTo="month"
      invalidDateMessage="Data inválida"
      onMonthChange={(date) => {
        handleDateChange(date);
        onChangeDate(date._d);
        setOpened(false);
      }}
      open={opened}
      onOpen={() => {
        setOpened(true);
      }}
      onClose={() => {
        setOpened(false);
      }}
      cancelLabel={null}
      okLabel={null}
    />
  );
}
